import { storeDataToIndexedDB } from 'Utils/manageIndexedDB';
import {
  // betslip actions
  VALIDATE_MBS_STATE,
  ADD_MULTIPLE_EVENTS_TO_BETSLIP,
  VALIDATE_BETSLIP_SUCCESS,
  VALIDATE_BETSLIP_FAILURE,
  RESET_BETSLIP,
  BETSLIP_EVENT_VERSION_WS_UPDATE,
  BETSLIP_EVENT_ODD_WS_UPDATE,
  BETSLIP_EVENT_BETTING_WS_STATUS_TOGGLE,
  BETSLIP_CLOSED,

  // raffle slip actions
  TOGGLE_TICKET_TO_RAFFLE_SLIP,
  CLEAR_RAFFLE_SLIP,

  // lottery slip actions
  TOGGLE_TICKET_TO_LOTTERY_SLIP,
  TOGGLE_TICKET_TO_SUPER_LOTTERY_SLIP,
  CLEAR_LOTTERY_SLIP,
  CLEAR_SUPER_LOTTERY_SLIP,

  // live score Filter actions
  SET_LIVE_SCORES_FILTER_REQUEST_OBJECT,
  GET_LIVE_SCORES_CLEAR_ALL_FILTER,

  // chance games actions
  TOGGLE_CG_NUMBER,
  TOGGLE_CG_EXTRA_NUMBER,
  SET_AUTO_CG_SELECTIONS,
  CLEAR_CG_COLUMN,
  CLEAR_CG_SLIP,

  // horse racing actions
  SELECT_ALL_HORSES,
  SELECT_HORSE,
  REMOVE_HORSE,
  REMOVE_ALL_HORSES,
  RESET_HR_BETSLIP,
  TOGGLE_HR_BETSLIP,
  SET_HR_BETSLIP_MULTIPLIER,
  SET_HR_BETSLIP_COUPON_COUNT,
  SET_HR_BETSLIP_ALL_VARIATION,

  //favoriteEvent actions
  ADD_FAVORITE_EVENT,
  REMOVE_FAVORITE_EVENT,
} from 'Store/constants';

const chanceGamesActions = [
  TOGGLE_CG_NUMBER,
  TOGGLE_CG_EXTRA_NUMBER,
  SET_AUTO_CG_SELECTIONS,
  CLEAR_CG_COLUMN,
  CLEAR_CG_SLIP
];

const betSlipActions = [
  VALIDATE_MBS_STATE,
  ADD_MULTIPLE_EVENTS_TO_BETSLIP,
  VALIDATE_BETSLIP_SUCCESS,
  VALIDATE_BETSLIP_FAILURE,
  RESET_BETSLIP,
  BETSLIP_EVENT_VERSION_WS_UPDATE,
  BETSLIP_EVENT_ODD_WS_UPDATE,
  BETSLIP_EVENT_BETTING_WS_STATUS_TOGGLE,
  BETSLIP_CLOSED,
];

const lotterySlipActions = [
  TOGGLE_TICKET_TO_LOTTERY_SLIP,
  CLEAR_LOTTERY_SLIP
];

const superLotterySlipActions = [
  TOGGLE_TICKET_TO_SUPER_LOTTERY_SLIP,
  CLEAR_SUPER_LOTTERY_SLIP
];

const raffleSlipActions = [
  TOGGLE_TICKET_TO_RAFFLE_SLIP,
  CLEAR_RAFFLE_SLIP
];

const liveScoresFilterActions = [
  SET_LIVE_SCORES_FILTER_REQUEST_OBJECT,
  GET_LIVE_SCORES_CLEAR_ALL_FILTER
];

const horseRacingActions = [
  SELECT_ALL_HORSES,
  SELECT_HORSE,
  REMOVE_HORSE,
  REMOVE_ALL_HORSES,
  RESET_HR_BETSLIP,
  TOGGLE_HR_BETSLIP,
  SET_HR_BETSLIP_MULTIPLIER,
  SET_HR_BETSLIP_COUPON_COUNT,
  SET_HR_BETSLIP_ALL_VARIATION
];

const favoritesActions = [
  ADD_FAVORITE_EVENT,
  REMOVE_FAVORITE_EVENT,
];

export const syncLocalStorage = ({ getState }) => {
  return next => action => {
    const returnValue = next(action);

    if (chanceGamesActions.includes(action.type)) {
      storeDataToIndexedDB('cgPlay', getState().chanceGames.cgPlay);
    }

    if (betSlipActions.includes(action.type)) {
      const betSlip = getState().betSlip;
      storeDataToIndexedDB('betSlip', {
        ...betSlip,
        isLoadedFromLS: false
      });
    }

    if (lotterySlipActions.includes(action.type)) {
      storeDataToIndexedDB('lotterySlip', getState().lottery.lotterySlipData);
    }

    if (superLotterySlipActions.includes('action.type')) {
      storeDataToIndexedDB('superLotterySlip', getState().lottery.superLotterySlipData);
    }

    if (raffleSlipActions.includes(action.type)) {
      storeDataToIndexedDB('raffleSlip', getState().raffle.raffleSlipData);
    }

    if (liveScoresFilterActions.includes(action.type)) {
      storeDataToIndexedDB('liveScoresFilterRequest', getState().liveScores.liveScoresFilters);
    }

    if (horseRacingActions.includes(action.type)) {
      storeDataToIndexedDB('horseRacingBetslip', getState().horseRacing.betSlip);
    }
  
    if (favoritesActions.includes(action.type)) {
      storeDataToIndexedDB('favorites', getState().favoriteEvents);
    }

    return returnValue;
  };
};
